import React, { useEffect, useState } from "react";
import StarRating from "./StarRating";
import { userReview } from "../core/_requests";

type FeedbackModalProps = {
  isOpen: boolean;
  onClose: () => void;
  redirectUrl: string;
  rating: number;
  totalStars: number;
  owner_email: string;
  starImage?: string;
};

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  isOpen,
  onClose,
  redirectUrl,
  rating,
  totalStars,
  owner_email,
  starImage,
}) => {
  const [message, setMessage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [hover, setHover] = useState(0);

  const basePath = process.env.PUBLIC_URL;
  const starSize = "clamp(36px, 8vw, 60px)";

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!isOpen) return null;

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);

    if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };
  const submitform = async () => {
    const data = {
      owner_email,
      message,
      firstName,
      user_email: email,
      rating,
    };
    userReview(data);

    const timer = setTimeout(() => {
      onClose();
      window.location.href = redirectUrl;
    }, 3000);

    return () => clearTimeout(timer);
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className=" rounded-xl p-6 w-[90%] max-w-md theme-bg-color"
        onClick={(e) => e.stopPropagation()}
      >
        {!submitted ? (
          <>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              {Array.from({ length: totalStars }, (_, i) => i + 1).map(
                (star) => {
                  const isActive =
                    star <= rating || (hover >= star && star > rating);
                  return (
                    <span
                      key={star}
                      style={{
                        cursor: "pointer",
                        width: starSize,
                        height: starSize,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {isActive ? (
                        <img
                          src={
                            starImage || `${basePath}/images/selected-star.png`
                          }
                          alt="selected star"
                          style={{
                            width: starSize,
                            height: starSize,
                          }}
                        />
                      ) : (
                        <span
                          style={{
                            fontSize: starSize,
                            color: "#ccc",
                            lineHeight: 1,
                          }}
                        >
                          ★
                        </span>
                      )}
                    </span>
                  );
                },
              )}
            </div>

            <div className="max-w-xl mx-auto mb-6 px-4">
              <div className="rounded-2xl border theme-border-color     theme-bg-color-invert p-5 text-center shadow-sm">
                <h3 className="text-base md:text-lg font-semibold     theme-text-color-bg  mb-2">
                  We value your feedback
                </h3>

                <p className="text-sm md:text-base     theme-text-color-bg">
                  Thanks for telling us what you liked and where you think we
                  can improve.
                </p>
              </div>
            </div>

            <textarea
              className="w-full border rounded-md p-2 mb-3 placeholder-gray-900 bg-gray-100"
              placeholder="Your feedback"
              maxLength={600}
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <p className="text-xs text-right mb-3">{message.length}/600</p>

            <input
              className="w-full border rounded-md p-2 mb-3 placeholder-gray-900 bg-gray-100"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />

            <input
              className={`w-full placeholder-gray-900 bg-gray-100 border rounded-md p-2 mb-1 ${
                emailError ? "border-red-500" : "border-gray-300"
              }`}
              type="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
            />

            {emailError && <p className="text-red-500 text-sm">{emailError}</p>}

            <button
              className="
    w-full py-2 rounded-md
    cursor-pointer
    theme-text-color-bg
    theme-bg-color-invert
    disabled:bg-gray-400
    disabled:text-gray-700
    disabled:cursor-not-allowed
  "
              onClick={() => {
                submitform();
                setSubmitted(true);
              }}
              disabled={!message || !firstName || !email || emailError !== ""}
            >
              Submit
            </button>
          </>
        ) : (
          <div className="text-center py-8">
            <h2 className="text-lg font-semibold mb-2">
              Thank you for your feedback!
            </h2>
            <p className="text-sm text-gray-600">
              Redirecting you back to the app…
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackModal;
